import { render, staticRenderFns } from "./DataOverview.vue?vue&type=template&id=1ff0f348&scoped=true"
import script from "./DataOverview.vue?vue&type=script&lang=js"
export * from "./DataOverview.vue?vue&type=script&lang=js"
import style0 from "./DataOverview.vue?vue&type=style&index=0&id=1ff0f348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff0f348",
  null
  
)

export default component.exports